export const stripTrailingSlash = pathname =>
  `${pathname.slice(0, -1)}${pathname.slice(-1).replace('/', '')}`;

export const getSortBy = (sortBy, sortDesc) => {
  return `${sortDesc ? '-' : ''}${sortBy}`;
};
